import { render, staticRenderFns } from "./PayrollManagerView.vue?vue&type=template&id=3685310e&scoped=true"
import script from "./PayrollManagerView.vue?vue&type=script&lang=js"
export * from "./PayrollManagerView.vue?vue&type=script&lang=js"
import style0 from "./PayrollManagerView.vue?vue&type=style&index=0&id=3685310e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3685310e",
  null
  
)

export default component.exports